// @flow

import React, { Component }     from 'react';
import { connect }              from 'react-redux';
import { Link }                 from 'react-router-dom';
import { getTranslate }         from 'react-localize-redux';
import { requestResetPassword } from 'actions/session/userAuth';
import { clearAuthMsg, setAuthMsg } from 'actions/session/authMsg';
import AuthMsg                  from '../authMsg/authMsg.js';
import validationHelper         from 'helpers/validation.helper';
import documentHelper           from 'helpers/document.helper';
import queryString              from 'query-string';
import './index.css';

class ResetPassword extends Component {

  state = {
    email      : '',
    formValid  : true,
    emailValid : false
  };

  // Component constructor
  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (e) => {
    //Save data to state
    const { id, value } = e.target;
    this.setState({ [id]: value });

    // Check for simple validation
    this.validateField(id, value);
  }

  componentWillMount() {
    const { translate } = this.props;
    // Document page title
    documentHelper.setTitle(translate('session.password.title_document'));
  }

  componentDidMount() {
    const { dispatch, translate } = this.props;
    let parsed = queryString.parse(this.props.location.search);

    if (parsed.email) {
      this.setState({ email: parsed.email.split(' ').join('+'), emailValid: true, formValid: true });
    }

    if (parsed.link_expired) {
      dispatch(setAuthMsg(translate('session.password.error_link_expired_or_used'), 'danger', true));
      this.setState({ formValid: false });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const { email } = this.state;
    const { dispatch, history } = this.props;

    // On every submit, clear out response alert messages
    dispatch(clearAuthMsg());
    this.setState({ formValid: true });

    // Make a reset password request
    dispatch(requestResetPassword(email, history)).then(res => {
      if( this.props.authMsg && this.props.authMsg.message !== '' ) {
        this.setState({ formValid: false });
      }
    });
  }

  // Validate form
  validateField = (field, value) => {
    let emailValid = this.state.emailValid;

    switch(field) {
      case 'email':
        emailValid = validationHelper.email(value);
        break;
      default:
        break;
    }

    this.setState({ emailValid: emailValid });
  }

  render() {
    const { email, formValid, emailValid } = this.state;
    const { translate } = this.props;

    return(
      <div className="reset-password">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
              <div className="top-header">
                <h2>{translate('session.password.title')}</h2>
                <h4>{translate('session.common.texts.text_use_application_email')}</h4>
              </div>
            </div>
          </div>
        </div>

        <div className="row main-content">
          <div className="col-xs-12 col-sm-8 col-sm-offset-2">
            <div className="row">
              <div className="col-xs-12">
                <form name="form_resetpassword" className="login-form" onSubmit={this.handleSubmit}>
                  {!formValid &&
                    <div className="error-float-message alert alert-danger">
                      <i className="icon-bell"></i>
                      <span><AuthMsg /></span>
                    </div>
                  }
                  <div className="form-group has-float-label">
                    <input type="email" id="email" value={email} onChange={this.handleChange} className="form-control" autoFocus required />
                    <label>{translate('session.field.field_email')}</label>
                    <span className="email-icon" />
                    <span className={"validation-check " + (!emailValid ? 'uncheck' : '')}></span>
                  </div>
                  <div className="form-group">
                    <div className="submit-wrap">
                      <div className="button-wrap">
                        <input type="submit" name="register" value={translate('session.password.button_send')} />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="row bottom">
          <div className="col-xs-12 col-lg-3 margin-center">
            <div className="bottom-box text-center">
              <div className="nick-bg-armdown"></div>
              <div className="info-box">
                <strong>{translate('session.common.texts.text_what_to_do_next')}</strong>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6 col-sm-offset-3">
            <div className="bottom-box text-center">
              <div className="circle-arrow-group">
                <div className="circle-arrow-right">
                  <div className="car-text text-center"><i className="fa fa-envelope"></i><strong>{translate('session.common.texts.text_check_your_email')}</strong><p>{translate('session.common.texts.text_inbox_or_spam')}</p></div>
                  <i className="car-top-left"></i>
                  <i className="car-bottom-left"></i>
                  <i className="car-middle"></i>
                  <i className="car-right"></i>
                </div>
                <div className="circle-arrow-left">
                  <div className="cal-text text-center"><i className="fa fa-check"></i><span>{translate('session.password.text_activate_and_set_password')}</span></div>
                  <i className="cal-top-right"></i>
                  <i className="cal-bottom-right"></i>
                  <i className="cal-middle"></i>
                  <i className="cal-left"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6 col-sm-offset-3 text-center fs-18">{translate('session.common.texts.success_text_have_account')} <Link to='/'><strong className="semibold">{translate('session.common.button_login')}</strong></Link><br /><br /></div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-sm-offset-3 text-center fs-14">{translate('session.common.hint.hint_checkout_faq')}</div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  authMsg  : state.authMsg
});

export default connect(mapStateToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/session/resetPassword/index.js